import { useParams } from 'react-router';
import { useGetUserQuery } from 'features/api/apiSlice';
import EmptyUserCard from 'components/cards/skeleton/EmptyUserCard';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserProviderId } from 'models/IUser';
import PatientFilePage from './PatientFilePage';
import SMILEPatientFilePage from './SMILE/PatientFilePage';
import VETLLARPatientFilePage from './VETLLAR/PatientFilePage';
import COMPASSPatientFilePage from './COMPASS/PatientFilePage';
import AURAPatientFilePage from './AURA/PatientFilePage';
import CHAMPPatientFilePage from './CHAMP/PatientFilePage';

const PatientFileResolverPage = () => {
  const { t } = useTranslation();
  const { userid } = useParams();

  const { data: patient, isLoading, isFetching } = useGetUserQuery(userid ?? '', { skip: !userid });

  if (isLoading) {
    return (
      <Grid container spacing={3}>
        <EmptyUserCard title={t('loading', 'Loading...')} />
      </Grid>
    );
  }

  if (isFetching) {
    return (
      <Grid container spacing={3}>
        <EmptyUserCard title={t('fetching', 'Fetching...')} />
      </Grid>
    );
  }

  switch (patient?.provider) {
    case UserProviderId.SMILE:
      return <SMILEPatientFilePage />;
    case UserProviderId.VETLLAR:
      return <VETLLARPatientFilePage />;
    case UserProviderId.AURA:
      return <AURAPatientFilePage />;
    case UserProviderId.COMPASS:
    case UserProviderId.CERTAIN:
      return <COMPASSPatientFilePage />;
    case UserProviderId.CHAMP:
    case UserProviderId.ICARE:
    case UserProviderId.KORE:
    case UserProviderId.AIQReady:
      return <CHAMPPatientFilePage />;
    default:
      return <PatientFilePage />;
  }
};

export default PatientFileResolverPage;